import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Services } from '@/services/services';

import './Main.css'
import { Translates } from '@/services/repository/i18n';
import { MainPageLayout } from '@/components/layout/MainLayout';
import { MachinePath } from '../../Common';
import { Machine } from '@/services/model/machine';
import { CurrentSession } from '@/services/repository/session';
import { MachineFailureCategory } from '@/services/repository/machines';
import { Failure, LoadFailure, SaveFailure } from './Model';
import { BackButton } from '@/components/layout/NavBar';

export const AddFailurePage1 = ({ services, session }: { services: Services, session?: CurrentSession }) => {
  const navigate = useNavigate()
  const machineId = useParams().machineid
  const [translates, setTranslates] = useState<Translates>()
  const [machine, setMachine] = useState<Machine>()
  const [failure, setFailure] = useState<Failure>()
  const [categories, setCategories] = useState<MachineFailureCategory[]>(services.machines.listFailureCategories())

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  useEffect(() => {
    fetch(`/api/communal/machines/byid/${machineId}`).then((response) => {
      return response.json()
    }).then((data) => {
      setMachine(data)
    })
  }, [machineId])

  useEffect(() => {
    if(machineId ===undefined) {
      return
    }
    setFailure(LoadFailure(machineId))
  }, [machineId])

  if (translates === undefined || machine === undefined || translates === undefined || failure === undefined || machineId === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='add-failure' services={services} translates={translates} session={session} path={MachinePath({ session, translates, machine })}
    navbarLeft={<BackButton services={services} translates={translates} />}>
      
    <h2 className='page-title'>{translates.for(`failures.add.title`)}</h2>
     
    <div className='category-container'>
      {categories.map((category) => <div className={`category-box ${category === failure.category ? 'selected' : ''}`} onClick={() => {
        const updated = {
          ...failure,
          category: category,
          form: {
            symptoms: category !== failure.category ? new Set<string>() : failure.form.symptoms
          }
        }
        setFailure(updated)
        SaveFailure(machineId, updated)
        navigate(`/communal/machine/${machineId}/failures/add/page2`)
      }}>
        <img src={`/public/img/failures/${category}.svg`} />
        <div className='title'>{translates.for(`failures.category.${category}`)}</div>
      </div>)}
    </div>
  </MainPageLayout>
}
